// react
import { useState } from "react";
// libs
import { AnimatePresence } from "framer-motion";
import styled, { css } from "styled-components";
// components
import { Box } from "../Box";
import ATSlide from "./ATSlide";
import { SliderButton } from "../SliderButton";
import { Container } from "../Container";
// other
import { interactiveGroupToSlideItem } from "../../helpers/transformers/interactive-slide";
import { ArtifactTheme } from "../../models/client";

interface ATSliderProps {
  artifactTheme: ArtifactTheme;
}

const ButtonContainer = styled.div`
  ${({ theme }) => css`
    ${theme.mediaQueries.lgDown} {
      position: absolute;
      height: 85vw;
      width: 100%;
      top: 0;
      pointer-events: none;
      z-index: 2;
      max-height: 500px;
    }
  `}
`;

function ATSlider({ artifactTheme }: ATSliderProps) {
  const [slideIndex, setSlideIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  const [innerSlideIndex, setInnerSlideIndex] = useState(0);

  const slides = artifactTheme.artifactGroups.map(interactiveGroupToSlideItem);

  const visualInnerSlides = slides.map((slide) => {
    const innerSlides = slide.innerSlides.map((innerSlide, i) => ({
      ...innerSlide,
    }));
    let visualSlides = [];
    if (innerSlides.length === 1) {
      visualSlides = innerSlides.map((slide) => ({ ...slide, key: 0 }));
    }
    if (innerSlides.length === 2) {
      visualSlides = Array(4)
        .fill(0)
        .reduce((acc, _, i) => {
          let index = 0;

          if (i === 0) {
            index = 1;
          }
          if (i > 0 && i <= innerSlides.length) {
            index = i - 1;
          }
          if (i > innerSlides.length) {
            index = i - innerSlides.length - 1;
          }

          acc = [...acc, { ...innerSlides.at(index), key: i }];
          return acc;
        }, []);
    }
    if (innerSlides.length > 2) {
      visualSlides = Array(6)
        .fill(0)
        .reduce((acc, _, i) => {
          // const index = i === 0 ? 1 : i - innerSlideIndex - 1;
          let index = 0;

          if (i === 0) {
            index = 1;
          }
          if (i > 0 && i <= innerSlides.length) {
            index = i - 1;
          }
          if (i > innerSlides.length) {
            index = i - innerSlides.length - 1;
          }

          acc = [...acc, { ...innerSlides.at(index), key: i }];
          return acc;
        }, []);
    }
    return visualSlides;
  });

  const handleLeftButtonClick = () => {
    if (innerSlideIndex > 0) {
      const prevInnerIndex = innerSlideIndex - 1;
      setDirection(-1);
      setInnerSlideIndex(prevInnerIndex);
      setSlideIndex(slideIndex);
      return;
    }

    const prevIndex = slideIndex === 0 ? slides.length - 1 : slideIndex - 1;
    const currentInnerSlidesLength = slides[prevIndex].innerSlides.length;
    setInnerSlideIndex(currentInnerSlidesLength - 1);
    setDirection(-1);
    setSlideIndex(prevIndex);
  };

  const handleRightButtonClick = () => {
    const currentInnerSlidesLength = slides[slideIndex].innerSlides.length;

    if (innerSlideIndex < currentInnerSlidesLength - 1) {
      const nextInnerIndex = innerSlideIndex + 1;
      setInnerSlideIndex(nextInnerIndex);
      setDirection(1);
      setSlideIndex(slideIndex);
      return;
    } else {
      setInnerSlideIndex(0);
    }

    const nextIndex = slideIndex === slides.length - 1 ? 0 : slideIndex + 1;
    setDirection(1);
    setSlideIndex(nextIndex);
  };

  return (
    <Box pb={[40, 80]}>
      <Box position="relative">
        <Container maxWidth={[0, null, null, 4]} px={[3, null, null, 5]}>
          <AnimatePresence exitBeforeEnter custom={direction}>
            <ATSlide
              key={slideIndex}
              slide={slides[slideIndex]}
              direction={direction}
              innerIndex={innerSlideIndex}
              visualInnerSlides={visualInnerSlides[slideIndex]}
            />
          </AnimatePresence>
        </Container>

        <ButtonContainer>
          <SliderButton direction="prev" onClick={handleLeftButtonClick}>
            Previous
          </SliderButton>
          <SliderButton direction="next" onClick={handleRightButtonClick}>
            Next
          </SliderButton>
        </ButtonContainer>
      </Box>
    </Box>
  );
}

export default ATSlider;
